<div [class.error]="data.error">
  <mat-icon>{{ data.icon }}</mat-icon>
  <span>{{ data.message }}</span>
</div>
